module.exports = __webpack_public_path__ + "static/group-croup-7dec5468b0ba2c6e59e251660a8a3301.png";